module.exports = __webpack_public_path__ + "static/media/kitchenMachineIcon.6ecb6d55.svg";